export default __webpack_public_path__ + "static/media/insta.0f3a1d90.svg";